export * from './external-link-directive.module';
